import {Card} from "../../../../../../../../components/card/card.jsx";
import DashCard from "../../../../../../../../components/dash-card/dash-card.jsx";
import CnpjRiskLevel from "./cnpj-risk-level.jsx";
import RegisteredProgram from "./registered-program.jsx";
import MostRegistered from "./most-registered.jsx";

export default function CnpjCard({ data }) {
    return (
        <Card className="dash-main-card col-span-3 row-span-2 h-full">
            <Card.Header className="border-b-0! bg-transparent!">
                <Card.Title className="bg-transparent text-[#F4FFFF] text-center translate-y-1.5 w-full text-(length:--font-lg)!">
                    CNPJs cadastrados
                </Card.Title>
            </Card.Header>
            <Card.Body className="flex flex-1 min-h-0 px-(--dash-pad-md)! pb-(--dash-pad-md)!">
                <DashCard width="100%" height="100%" className="h-full min-h-0">
                    <section className="h-full grid grid-rows-[2.2fr_1.5fr_0.8fr] gap-(--dash-pad-md)">
                        <CnpjRiskLevel data={data} />
                        <RegisteredProgram data={data} />
                        <MostRegistered data={data} />
                    </section>
                </DashCard>
            </Card.Body>
        </Card>
    )
}
